var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoldericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00424 5.09054C0.950361 4.50492 1.417 4 2.01209 4H15.9879C16.583 4 17.0496 4.50492 16.9958 5.09054L16.1678 14.0905C16.1204 14.6056 15.6833 15 15.1599 15H2.8401C2.31669 15 1.87964 14.6056 1.83225 14.0905L1.00424 5.09054Z",
    fill: "#D7E3F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91592 2V4H16.0841V3.5C16.0841 2.94772 15.631 2.5 15.0721 2.5H8.01764C7.68256 2.5 7.3692 2.33611 7.18078 2.06231L6.75094 1.43769C6.56252 1.16389 6.24916 1 5.91408 1H2.92793C2.36901 1 1.91592 1.44772 1.91592 2Z",
    fill: "#D7E3F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00424 5.09054C0.950361 4.50492 1.417 4 2.01209 4H15.9879C16.583 4 17.0496 4.50492 16.9958 5.09054L16.1678 14.0905C16.1204 14.6056 15.6833 15 15.1599 15H2.8401C2.31669 15 1.87964 14.6056 1.83225 14.0905L1.00424 5.09054Z",
    stroke: "#75A8D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91592 2V4H16.0841V3.5C16.0841 2.94772 15.631 2.5 15.0721 2.5H8.01764C7.68256 2.5 7.3692 2.33611 7.18078 2.06231L6.75094 1.43769C6.56252 1.16389 6.24916 1 5.91408 1H2.92793C2.36901 1 1.91592 1.44772 1.91592 2Z",
    stroke: "#75A8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldericon);
export default __webpack_public_path__ + "static/media/foldericon.df104e1149d00cbdfa459295c7b962c3.svg";
export { ForwardRef as ReactComponent };